import React from 'react';
import { COMPARE_MAX } from '../../config/constants';
import { getPropertyCardImage } from '../../utils/properties';

const CompareTray = ({ compareList, onRemove, onClear, onCompareTrigger }) => {
  if (!compareList || compareList.length === 0) return null;
  return (
    <div className="compare-tray" role="region" aria-label="Compare listings">
      <div className="compare-tray-icon" aria-hidden="true">
        <i className="fas fa-right-left"></i>
      </div>
      <div className="compare-tray-meta">
        <h4>Compare listings</h4>
        <p>{compareList.length} of {COMPARE_MAX} selected</p>
      </div>
      <div className="compare-tray-items">
        {compareList.map((prop) => (
          <div key={prop.id} className="compare-tray-chip">
            <img src={getPropertyCardImage(prop)} alt="" />
            <span>{(prop.title || "Listing").substring(0, 18)}{(prop.title || "").length > 18 ? "…" : ""}</span>
            <button type="button" onClick={() => onRemove(prop.id)} aria-label={`Remove ${prop.title} from compare`}>×</button>
          </div>
        ))}
      </div>
      <div className="compare-tray-actions">
        <button
          type="button"
          className="btn btn-primary btn-sm"
          disabled={compareList.length < 2}
          onClick={onCompareTrigger}
        >
          Compare now
        </button>
        <button type="button" className="btn btn-ghost btn-sm" onClick={onClear}>Clear</button>
      </div>
    </div>
  );
};

export default CompareTray;
